<template>
  <t-config-provider :global-config="globalConfig">
    <!-- <KeepAlive :include="['Login']">
      <RouterView />
    </KeepAlive> -->

    <router-view v-slot="{ Component }">
      <!-- <keep-alive :include="['Login']"> -->
      <component :is="Component" />
      <!-- </keep-alive> -->
    </router-view>
  </t-config-provider>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { getTDesignLocale } from './settings/globalConfig';

// 全局特性配置，引入英文语言配置包 enConfig
const globalConfig = getTDesignLocale();

// const click = () => {
//   // 成功关闭弹窗
//   if (window.electron.ipcRenderer) window.electron.ipcRenderer.send('close')
// }
onMounted(() => {
  document.documentElement.setAttribute('theme-mode', 'light');
});
</script>
<style>
@font-face {
  font-family: 'KoneFont';
  src: url('@/assets/fonts/Inter-Regular.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap; /* 可选，控制字体加载时的显示行为 */
}
body {
  font-family: 'KoneFont', sans-serif !important;
  --td-font-family: 'KoneFont', sans-serif !important;
  --td-font-family-medium: 'KoneFont', sans-serif !important;
}

div,
span {
  font-family: 'KoneFont', sans-serif;
}
</style>
